export default {
  app: {
    name: "WBO",
    full: "Winbox Back Office",
    minimized: "WBO"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  login_success: "Login successfully",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  permission_denied: "Permission Denied!!!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_name: "Search by Name",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"?",
  successful_change_password: "You have successfully change password.",
  no_records: "No records",
  invalidToken: "Invalid Token",
  inactive_account: "Inactive account",
  invalid_amount: "Invalid amount",

  account_exists: "Account is already exists.",

  block_sub_account_confirm: "Are you sure want to block sub account?",
  block_sub_account_cancel: "Block sub account failed.",
  block_sub_account_success: "Sub account successfully blocked!",

  create_new_account_confirm: "Are you sure want to create new account?",
  create_new_account_cancel: "Create new account failed",
  create_new_account_success: "New account successfully created!",
  copy_all_upline: "Copy soccer HDP upline to all sport types",
  copy_all_account: "Copy soccer HDP account to all sport types",
  copy_all_remaining: "Copy soccer HDP remaining to all sport types",
  copy_all_min: "Copy soccer HDP min to all sport types",
  copy_all_min_bet: "Copy soccer min bet to all sport types",
  copy_all_max_bet: "Copy soccer max bet to all sport types",
  copy_all_max_per_match: "Copy soccer max per match to all sport types",
  copy_success: "Copy successfully",
  invalid_platform: "Unable to update platform.",

  search_with_working_date: "Search with working date",

  unblock_sub_account_confirm: "Are you sure want to unblock sub account?",
  unblock_sub_account_cancel: "Unblock sub account failed.",
  unblock_sub_account_success: "Sub account successfully unblocked!",
  update_currency_confirm: "Are you sure want to update currency rate?",
  update_currency_cancel: "Update currency rate failed.",
  update_currency_success: "Currency rate successfully updated!",
  update_account_password_confirm: "Are you sure want to update account password?",
  update_account_password_cancel: "Update account password failed.",
  update_account_password_success: "Password successfully updated!",
  update_account_status_confirm: "Are you sure want to update account status?",
  update_account_status_cancel: "Update account status failed.",
  update_account_status_success: "Account status successfully updated!",
  update_account_commission_confirm: "Are you sure want to update account commission?",
  update_account_commission_cancel: "Update account commission failed.",
  update_account_commission_success: "Account commission successfully updated!",
  update_account_position_confirm: "Are you sure want to update account position taking?",
  update_account_position_cancel: "Update account position taking failed.",
  update_account_position_success: "Account position taking successfully updated!",
  update_account_bet_limit_confirm: "Are you sure want to update account bet limit?",
  update_account_bet_limit_cancel: "Update account bet limit failed.",
  update_account_bet_limit_success: "Account bet limit successfully updated!",
  update_account_profile_confirm: "Are you sure want to update account profile?",
  update_account_profile_cancel: "Update account profile failed.",
  update_account_profile_success: "Account profile successfully updated!",
  unblock_account_profile_confirm: "Are you sure want to unblock account profile?",
  unblock_account_profile_cancel: "Unblock account profile failed.",
  unblock_account_profile_success: "Account profile successfully unblocked!",
  update_platform_settings_confirm: "Are you sure want to update account platform?",
  update_platform_settings_cancel: "Update account platform failed.",
  update_platform_settings_success: "Account platform successfully updated!",
  update_cash_mode_confirm: "Are you sure want to update account cash mode?",
  update_cash_mode_cancel: "Update account cash mode failed.",
  update_cash_mode_success: "Account cash mode successfully updated!",
  settlement_confirm: "Are you sure want to proceed settlement?",
  settlement_cancel: "Settlement failed",
  settlement_success: "Settlement successfully processed!",
  transfer_confirm: "Are you sure want to proceed transfer?",
  transfer_cancel: "Transfer failed",
  transfer_success: "Transfer successfully processed!",
  successful_manual_process_statement : "Process statement (manual) successfully!",
  search_in_current_month: "Search in Current Month",
  search_in_historical_month: "Search in Historical Month",
  no_changes: "No changes",

  reset_account_ip_confirm: "Are you sure want to reset account IP?",
  reset_account_ip_cancel: "Reset account IP failed.",
  reset_account_ip_success: "Account IP successfully reset!",

  reset_account_pt_confirm: "Are you sure want to reset account PT (Slots)?",
  reset_account_pt_cancel: "Reset account PT (Slots) failed.",
  reset_account_pt_success: "Account PT (Slots) successfully reset!",

  account_sub_block_confirm: "Are you sure want to block this sub account?",
  account_sub_block_cancel: "Block sub account failed.",
  account_sub_block_success: "Sub account successfully blocked!",

  account_sub_unblock_confirm: "Are you sure want to unblock this sub account?",
  account_sub_unblock_cancel: "Unblock sub account failed.",
  account_sub_unblock_success: "Sub account successfully unblocked!",

  account_freeze_confirm: "Are you sure want to freeze this account?",
  account_freeze_cancel: "Freeze account failed.",
  account_freeze_success: "Account successfully freezed!",

  update_tournament_confirm: "Are you sure want to update account tournament?",
  update_tournament_cancel: "Update account tournament failed.",
  update_tournament_success: "Account tournament successfully updated!",

  add_tournament_op_confirm: "Are you sure want to add tournament operator?",
  add_tournament_op_cancel: "Add tournament operator failed.",
  add_tournament_op_success: "Tournament operator successfully added!",

  delete_tournament_op_confirm: "Are you sure want to delete tournament operator?",
  delete_tournament_op_cancel: "Delete tournament operator failed.",
  delete_tournament_op_success: "Tournament operator successfully deleted!",

  settle_amount_gt_yesterday_balance: "Settle amount is greater than yesterday balance.",
  ok: "Succeed",
  block_account_confirm: "Are you sure want to block this account?",
  unblock_account_confirm: "Are you sure want to unblock this account?",
  change_bank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_bank_group_default_confirm: "Are you sure want to set \"{name}\" as default bank group?",
  select_option: "Select your option",
  adjust_amount: "Support minus sign (-) to deduct balance from bank account balance",


  continue_confirm: "Are you sure want to continue?",
  choose_file_first: "Please choose a image file to upload first.",
  phoneFormat: "e.g. 976XXXXXXXX",
  autoplayPolicy: "Please click OK to allow auto play sound.",

  member_tac_activate: "Are you sure want to activate this member?"
};
